// extracted by mini-css-extract-plugin
export default {"Panel":"Panel_Panel__XaiC7"};